import { render, staticRenderFns } from "./regles.vue?vue&type=template&id=f9b3b736&"
import script from "./regles.vue?vue&type=script&lang=js&"
export * from "./regles.vue?vue&type=script&lang=js&"
import style0 from "./regles.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
